import React, { useMemo, useState } from 'react';
import { fmtNum } from './monthlyCalculationUtils';
import { S } from './EventList.styles';
import {
  shortDate, statusFor, metaFor, eventTypeLabel, decisionOptions, editableStatus,
  sourceTextFor, amountText, itemSummary, summaryFor,
} from './eventListModel';

// touch: 휴대폰 관리자 화면(2026-10-06) — 처리 칸·전체 보기 버튼을 40px 로. 마케터 정산서 화면은 넘기지 않아 그대로.
export function EventList({ events = [], onDecisionChange = null, readOnly = false, touch = false }) {
  const [showAll, setShowAll] = useState(false);
  const summary = useMemo(() => summaryFor(events), [events]);
  if (!events.length) return <div style={S.empty}>청구에 반영된 계약/취소가 없습니다.</div>;

  const visible = showAll ? events : events.slice(0, 10);
  return (
    <div style={S.wrap}>
      <div style={S.summary}>
        <div style={S.summaryLeft}>
          <span style={S.summaryTitle}>청구 반영 계약</span>
          <span style={S.summaryText}>총 {summary.total.toLocaleString('ko-KR')}건 · 반영 {fmtNum(summary.weighted)}장</span>
        </div>
        <div style={S.summaryLeft}>
          {summary.pending > 0 && <span style={S.chip('warn')}>확인필요 {summary.pending}건</span>}
          {summary.excluded > 0 && <span style={S.chip('muted')}>제외 {summary.excluded}건</span>}
        </div>
      </div>

      <div style={S.list}>
        {visible.map((event, index) => {
          const isCancel = event.type === 'cancel';
          const status = statusFor(event, readOnly);
          const currentMeta = metaFor(event, status);
          const canEdit = !!onDecisionChange && !readOnly;
          const sourceText = sourceTextFor(event);
          const itemText = itemSummary(event.items || []);
          return (
            <div key={`${event.contractId}-${event.date}-${event.type}-${index}`} style={S.card}>
              <div style={S.badges}>
                <span style={S.chip('blue')}>{shortDate(event.date)}</span>
                <span style={S.chip(isCancel ? 'danger' : 'blue')}>{eventTypeLabel(event)}</span>
                <span style={S.chip(currentMeta.tone)}>{currentMeta.label}</span>
              </div>

              <div style={S.main}>
                <div style={S.title} title={event.companyName || '-'}>
                  {event.companyName || '-'}
                </div>
                <div style={S.meta}>
                  <span>{event.salesPersonName || '-'}</span>
                  {event.meetingDate && <span>· 미팅 {shortDate(event.meetingDate)}</span>}
                  {event.isReorder && <span>· 재계약</span>}
                  {itemText && <span style={S.itemText} title={itemText}>· {itemText}</span>}
                </div>
                {sourceText && <div style={S.sourceText} title={sourceText}>{sourceText}</div>}
              </div>

              <div style={S.amount(isCancel)}>{amountText(event)}</div>

              {canEdit && (
                <label style={S.selectWrap}>
                  <span style={S.selectLabel}>처리</span>
                  <select
                    style={touch ? { ...S.select, ...S.selectTouch } : S.select}
                    value={editableStatus(status)}
                    onChange={(e) => onDecisionChange(event, e.target.value)}
                  >
                    {decisionOptions(event).map(([nextStatus, label]) => (
                      <option key={nextStatus} value={nextStatus}>{label}</option>
                    ))}
                  </select>
                </label>
              )}
            </div>
          );
        })}
      </div>

      {events.length > 10 && (
        <button type="button" style={touch ? { ...S.more, minHeight: 40 } : S.more} onClick={() => setShowAll((prev) => !prev)}>
          {showAll ? '접기' : `전체 보기 (${events.length}건)`}
        </button>
      )}
    </div>
  );
}
